"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _button = _interopRequireDefault(require("@ux/button"));
var _text = _interopRequireDefault(require("@ux/text"));
var _chevronDown = _interopRequireDefault(require("@ux/icon/chevron-down"));
var _accessories = require("./accessories");
const _excluded = ["children", "className", "emphasis", "icon", "id", "onClick", "rotation", "target", "title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const UX_SUMMARY_CLASSNAME = 'ux-summary';
function getAttributes(props) {
  const {
    onClick,
    'aria-controls': ariaControls,
    'aria-expanded': ariaExpanded
  } = props;
  if (typeof onClick === 'function') {
    return {
      onClick,
      onKeyDown(event) {
        if ([' ', 'Enter'].includes(event.key)) {
          event.preventDefault();
          onClick(event);
        }
      },
      'tabIndex': 0,
      'role': 'button',
      'aria-controls': ariaControls,
      'aria-expanded': ariaExpanded
    };
  }
  return {};
}
function getEmphasisIcon(emphasis) {
  if (emphasis && _accessories.ACCESSORIES[emphasis]) {
    const Accessory = _accessories.ACCESSORIES[emphasis];
    return /*#__PURE__*/_react.default.createElement(Accessory, {
      className: `${UX_SUMMARY_CLASSNAME}-accessory--${emphasis}`,
      role: "presentation"
    });
  }
  return null;
}

/**
 * Creates a <Summary/> component
 *
 * @param {Object} props - Configuration object
 * @param {Node} [props.children] - Additional content for the summary
 * @param {String} [props.className] - Optional class for positioning
 * @param {String} [props.emphasis] - Provides visual feedback
 * @param {Component} [props.icon] - A @ux/icon component
 * @param {String} props.id - Unique identifier
 * @param {Function} [props.onClick] - Fires when the component is clicked, turns on interactivity
 * @param {String} [props.rotation] - CSS rotation for chevron
 * @param {String} [props.target] - Determines which part is interactive
 * @param {Node} props.title - Title for the summary
 * @returns {Component} - A <Summary/> component
 */
function Summary(_ref) {
  let {
      children,
      className,
      emphasis,
      icon,
      id,
      onClick,
      rotation,
      target = 'root',
      title
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  delete rest.style;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    "data-version": "2400"
  }, rest, target === 'root' ? getAttributes(_objectSpread({
    onClick
  }, rest)) : {}, {
    className: (0, _classnames.default)(`${UX_SUMMARY_CLASSNAME}-shell`, className, {
      [`${UX_SUMMARY_CLASSNAME}--interactive`]: typeof onClick === 'function'
    }),
    style: {
      '--ux-summary--chevron-rotation': rotation
    }
  }), icon || getEmphasisIcon(emphasis), /*#__PURE__*/_react.default.createElement("div", {
    className: `${UX_SUMMARY_CLASSNAME}-flex`
  }, /*#__PURE__*/_react.default.createElement(_text.default.div, {
    as: "title",
    id: id
  }, title), children ? /*#__PURE__*/_react.default.createElement(_text.default.div, {
    as: "paragraph"
  }, children) : null), /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    "aria-labelledby": id,
    icon: /*#__PURE__*/_react.default.createElement(_chevronDown.default, null)
  }, target === 'root' ? {} : getAttributes(_objectSpread({
    onClick
  }, rest)), {
    className: `${UX_SUMMARY_CLASSNAME}-chevron`
  })));
}
Summary.ACCESSORIES = _accessories.ACCESSORIES;
Summary.propTypes = {
  /** Additional content for the summary */
  children: _propTypes.default.node,
  /** Optional class for positioning */
  className: _propTypes.default.string,
  /** Provides visual feedback */
  emphasis: _propTypes.default.oneOf(Object.keys(_accessories.ACCESSORIES)),
  /** A @ux/icon component */
  icon: _propTypes.default.node,
  /** Unique identifier */
  id: _propTypes.default.string.isRequired,
  /** Fires when the component is clicked, turns on interactivity */
  onClick: _propTypes.default.func,
  /** CSS rotation for chevron */
  rotation: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** Determines which part is interactive */
  target: _propTypes.default.oneOf(['root', 'button']),
  /** Title for the summary */
  title: _propTypes.default.node.isRequired
};
Summary.displayName = 'Summary';
var _default = exports.default = Summary;